import React from 'react';
import { useTheme } from '../../context/ThemeProvider';
import './ToggleTheme.css';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <label className="switch-with-icon">
      <input
        type="checkbox"
        checked={theme === 'dark'}
        onChange={toggleTheme}
      />
      <span className="slider">
        <span className="icon sun">☀️</span>
        <span className="icon moon">🌙</span>
      </span>
    </label>
  );
};

export default ThemeToggle;
